import { UNIT_CM, UNIT_M, UNIT_IN } from "./heightUnits";

import { UNIT_KG, UNIT_STONE, UNIT_POUNDS } from "./weightUnits";

export const IMPERIAL = "imperial";
export const METRIC = "metric";
export const IMPERIAL_LOCALES = ["US", "UK", "CA", "FC"];
export const LOCALES_THAT_USE_EITHER_SYSTEM = ["UK", "CA", "FC"];

export const getAlternateSystem = system =>
  system === METRIC ? IMPERIAL : METRIC;

const CORE_PROFILE_HEIGHT_WEIGHT_UNITS = {
  US: IMPERIAL,
  UK: IMPERIAL,
  AU: METRIC,
  CA: IMPERIAL,
  FC: IMPERIAL,
  FR: METRIC,
  NB: METRIC,
  DE: METRIC,
  FB: METRIC,
  SE: METRIC
};

const heightWeightUnitsForSystem = {
  imperial: {
    UK: {
      height: UNIT_IN,
      weight: UNIT_STONE
    },
    US: {
      height: UNIT_IN,
      weight: UNIT_POUNDS
    },
    CA: {
      height: UNIT_IN,
      weight: UNIT_POUNDS
    },
    FC: {
      height: UNIT_IN,
      weight: UNIT_POUNDS
    }
  },
  metric: {
    AU: {
      height: UNIT_M,
      weight: UNIT_KG
    },
    CA: {
      height: UNIT_CM,
      weight: UNIT_KG
    },
    DE: {
      height: UNIT_CM,
      weight: UNIT_KG
    },
    ES: {
      height: UNIT_M,
      weight: UNIT_KG
    },
    FB: {
      height: UNIT_M,
      weight: UNIT_KG
    },
    FC: {
      height: UNIT_CM,
      weight: UNIT_KG
    },
    FR: {
      height: UNIT_CM,
      weight: UNIT_KG
    },
    NB: {
      height: UNIT_M,
      weight: UNIT_KG
    },
    SE: {
      height: UNIT_CM,
      weight: UNIT_KG
    },
    UK: {
      height: UNIT_CM,
      weight: UNIT_KG
    }
  }
};

export const usesBothSystems = locale =>
  LOCALES_THAT_USE_EITHER_SYSTEM.includes(locale);

export function preferredMeasurementSystem({
  preferredHeightWeightUnits,
  market
} = {}) {
  if (!preferredHeightWeightUnits) {
    preferredHeightWeightUnits =
      CORE_PROFILE_HEIGHT_WEIGHT_UNITS[market] || METRIC;
  }
  return preferredHeightWeightUnits;
}

export function measurementUnitsForMarketAndSystem(market, system) {
  const defaultHeightWeight = {
    height: UNIT_CM,
    weight: UNIT_KG
  };

  if (!market) {
    return defaultHeightWeight;
  }

  if (!system) {
    system = CORE_PROFILE_HEIGHT_WEIGHT_UNITS[market];
  }

  // All markets need correct imperial for weight loss calculations.
  if (system === "imperial" && !heightWeightUnitsForSystem[system]?.[market]) {
    return heightWeightUnitsForSystem.imperial.US;
  }

  return heightWeightUnitsForSystem[system]?.[market] || defaultHeightWeight;
}
